module.exports = __webpack_public_path__ + "img/zi_2.4b666aa3.png";